var {AmpersandView} = require('catalog/libs');

/**
 * Product Card Spec List view
 */

module.exports = AmpersandView.extend({

	template: function(context) {
		var html = [
			'<li>',
			'  <h5 class="product-spec-attribute">' + context.model.name + '</h5><span class="small">' + context.model.value + '</span>',
			'</li>'
		].join('\n');

		return html;
	}

});
